<template>
  <div class="d-flex flex-row tooltip">
    <div class="d-flex flex-row align-center">
      <v-img src="@/assets/medal_gold.png" max-width="28px"/>
      <div class="ml-2">
        {{gold}}
      </div>
    </div>
    <div class="d-flex flex-row align-center ml-4">
      <v-img src="@/assets/medal_silver.png" max-width="28px"/>
      <div class="ml-2">
        {{silver}}
      </div>
    </div>
    <div class="d-flex flex-row align-center ml-4">
      <v-img src="@/assets/medal_bronze.png" max-width="28px"/>
      <div class="ml-2">
        {{bronze}}
      </div>
    </div>
    <span class="description_top">コンペティションメダル</span>
  </div>
</template>

<script>
export default {
  name: "CompetitionMedals",
  props: {
    gold: {
      type: Number
    },
    silver: {
      type: Number
    },
    bronze: {
      type: Number
    },
  }
}
</script>

<style scoped>
.tooltip {
  position: relative;
}
.description_top { /* ツールチップのスタイル */
  width: 150px; /* 横幅 */
  position: absolute;
  left: 50%;
  bottom: 80%; /* Y軸の位置 */
  transform: translateX(-50%);
  margin-bottom: 8px; /* テキストとの距離 */
  padding: 8px;
  border-radius: 10px; /* 角の丸み */
  background-color: #666;
  font-size: 0.7em;
  color: #fff;
  text-align: center;
  visibility: hidden; /* ツールチップを非表示に */
  opacity: 0; /* 不透明度を0％に */
  z-index: 1;
  transition: 0.5s all; /* マウスオーバー時のアニメーション速度 */
}

.tooltip:hover .description_top { /* マウスオーバー時のスタイル */
  bottom: 100%; /* Y軸の位置 */
  visibility: visible; /* ツールチップを表示 */
  opacity: 1; /* 不透明度を100％に */
}
</style>